import { render, staticRenderFns } from "./Winner.vue?vue&type=template&id=6bdf4a43&scoped=true&"
import script from "./Winner.vue?vue&type=script&lang=js&"
export * from "./Winner.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./Winner.vue?vue&type=style&index=1&id=6bdf4a43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdf4a43",
  null
  
)

export default component.exports